/* cart-drawer-cross-sell.js
- Minimal cross-sell UI.
- Cross-sell products are OUTSIDE the configurator bundle.
- Pricing comes from the active RPD Advanced Discount configuration; cart lines carry semantic _rpd_promo/_rpd_context properties.
*/
(() => {
  let busy = false;
  let configPromise = null;
  const ADVANCED_ENDPOINT = '/apps/forus-promotions/advanced-discounts';

  const NOVEMBER_PREVIEW_TOKENS = {
    'faber:coffee': { percentage: 20, contexts: { bundle: 30 } },
    'faber:accessory': { percentage: 10, contexts: { bundle: 20 } },
  };

  function isThemePreview() {
    return Boolean(
      document.getElementById('PBarNextFrame') ||
      document.documentElement.classList.contains('shopify-design-mode') ||
      window.Shopify?.designMode
    );
  }

  async function previewFallback(tokens) {
    if (Object.keys(tokens || {}).length) return tokens;
    for (let attempt = 0; attempt < 20; attempt += 1) {
      if (isThemePreview()) return NOVEMBER_PREVIEW_TOKENS;
      await new Promise((resolve) => window.setTimeout(resolve, 50));
    }
    return {};
  }

  const ROOT_SEL = '[data-cart-drawer-cross-sell]';
  const ADD_BTN_SEL = '[data-cart-drawer-cross-sell-add]';
  const STYLE_ID = 'cart-drawer-cross-sell-ui-min-v1';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cart-drawer-cross-sell { margin-top: 1.2rem; }
      .cart-drawer-cross-sell__header { display:flex; align-items:center; justify-content:space-between; gap:.75rem; margin-bottom:.6rem; }
      .cart-drawer-cross-sell__title { margin:0; font-size:.95rem; line-height:1.2; }
      .cart-drawer-cross-sell__list{ display:flex; flex-direction:column; gap:.6rem; }
      .cart-drawer-cross-sell__item{
        display:grid; grid-template-columns:64px 1fr auto; gap:.75rem; align-items:center;
        padding:.65rem .75rem; border:1px solid rgba(var(--color-foreground,18,18,18),.08);
        border-radius:14px; background:rgb(var(--color-background,255,255,255));
      }
      .cart-drawer-cross-sell__media{ display:block; width:64px; }
      .cart-drawer-cross-sell__media img{ width:64px; height:64px; object-fit:cover; border-radius:10px; display:block; }
      .cart-drawer-cross-sell__info{ min-width:0; display:flex; flex-direction:column; gap:.25rem; }
      .cart-drawer-cross-sell__product-title{
        display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
        text-decoration:none; font-size:.92rem; line-height:1.2; word-break:break-word;
      }
      .cart-drawer-cross-sell__add{
        width:2.15rem; height:2.15rem; min-width:2.15rem; min-height:2.15rem; padding:0;
        border-radius:999px; border:1px solid rgba(var(--color-foreground,18,18,18),.12);
        background:transparent; display:grid; place-items:center; cursor:pointer;
        color:rgb(var(--color-foreground,18,18,18));
      }
      .cart-drawer-cross-sell__add:hover{ background:rgba(var(--color-foreground,18,18,18),.06); }
      .cart-drawer-cross-sell__add:active{ background:rgba(var(--color-foreground,18,18,18),.10); }
      .cart-drawer-cross-sell__add[disabled]{ opacity:.35; cursor:not-allowed; }
      .cart-drawer-cross-sell__add > span{ font-size:1.25rem; line-height:1; transform:translateY(-1px); }
    `;
    document.head.appendChild(style);
  }

  function getDrawerSectionIds() {
    const drawer = document.querySelector('cart-drawer-component');
    const raw = drawer?.getAttribute('sections') || drawer?.dataset?.sections || '';
    if (raw) return raw.split(',').map(s => s.trim()).filter(Boolean);

    const ids = Array.from(document.querySelectorAll('cart-items-component'))
      .map(el => el?.dataset?.sectionId)
      .filter(Boolean);

    return ids.length ? ids : ['cart-drawer', 'cart-icon-bubble'];
  }

  async function cartAdd(items) {
    const payload = {
      items,
      sections: getDrawerSectionIds(),
      sections_url: window.location.pathname,
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });

    const json = await res.json().catch(() => ({}));
    if (!res.ok || json?.status) throw json;
    return json;
  }

  function dispatchCartUpdate(cartResponse) {
    const ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cartResponse,
      sourceId: 'cart-drawer-cross-sell',
      data: {
        source: 'cart-drawer-cross-sell',
        didError: false,
        itemCount: cartResponse?.item_count,
        sections: cartResponse?.sections,
      },
    };
    document.dispatchEvent(ev);
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }


  function money(cents){
    try{return new Intl.NumberFormat((document.documentElement.lang||'it-IT').replace('_','-'),{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100)}catch(e){return '€'+((Number(cents)||0)/100).toFixed(2)}
  }
  function loadConfig(){
    if(!configPromise)configPromise=fetch(ADVANCED_ENDPOINT,{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.json()).then(j=>previewFallback(j?.tokens||{})).catch(()=>({}));
    return configPromise;
  }
  async function refreshPrices(){
    const tokens=await loadConfig();
    document.querySelectorAll(ADD_BTN_SEL).forEach(btn=>{
      const role=String(btn.dataset.rpdRole||'accessory');
      const context=String(btn.dataset.rpdContext||'standalone').toLowerCase();
      const token=role==='coffee'?'faber:coffee':'faber:accessory';
      const cfg=tokens[token]||{};
      const rate=Number(cfg?.contexts?.[context] ?? cfg?.percentage ?? 0);
      const cents=Number(btn.dataset.rpdPriceCents||0);
      const item=btn.closest('[data-cart-drawer-cross-sell-item]');
      if(!item||!cents||!rate)return;
      const final=Math.round(cents*(1-rate/100));
      const current=item.querySelector('[data-rpd-xs-current]');
      const original=item.querySelector('[data-rpd-xs-original]');
      const badge=item.querySelector('[data-rpd-xs-badge]');
      if(current)current.textContent=money(final);
      if(original){original.textContent=money(cents);original.hidden=false;}
      if(badge){badge.textContent='-'+String(rate).replace('.',',')+'%';badge.hidden=false;}
    });
  }

  function initAll() {
    ensureStyles();
    document.querySelectorAll(ROOT_SEL).forEach(() => {});
    refreshPrices();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.(ADD_BTN_SEL);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const rawId = btn.getAttribute('data-variant-id') || btn.dataset.variantId || '';
    const variantId = Number(String(rawId).trim());
    if (!Number.isFinite(variantId) || variantId <= 0) return;

    if (busy) return;
    busy = true;
    btn.disabled = true;

    try {
      const role = String(btn.dataset.rpdRole || 'accessory').trim();
      const context = String(btn.dataset.rpdContext || 'standalone').trim();
      const properties = {
        _faber_role: role,
        _faber_source: 'cart_cross_sell',
        _rpd_promo: role === 'coffee' ? 'faber:coffee' : 'faber:accessory',
        _rpd_context: context,
      };

      const cartResponse = await cartAdd([
        {
          id: variantId,
          quantity: 1,
          properties,
        },
      ]);

      dispatchCartUpdate(cartResponse);
      openDrawer();
    } catch (err) {
      console.error('Cart cross-sell add failed:', err);
      alert('Errore durante l’aggiunta al carrello. Riprova.');
    } finally {
      busy = false;
      btn.disabled = false;
    }
  }, true);

  window.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('cart:update', () => requestAnimationFrame(initAll));
})();
